import { Wizard } from 'react-use-wizard';

import { GuidedPlanningProvider } from './context';
import { GuidedPlanningHeader } from './components/guided-planning-header';
import { WizardAnimatedStep } from './components/animated-step';
import {
  FundingPlanOverviewStep,
  AssetSelectionStep,
  AssessmentIntroStep,
  AssessmentAccountsStep,
  AssessmentProjectionStep,
  PreferencesDeathBenefitsStep,
  PreferencesBenefitStructureStep,
  QuotesLoadingStep,
  QuotesSelectionStep,
  QuotesFundingStep,
  PlanComparisonStep,
} from './components/steps';
import { useWizardStepSync } from './hooks';

interface GuidedFinancialPlanningPageProps {
  clientId: string;
}

function GuidedPlanningWizard() {
  const { startIndex, onStepChange } = useWizardStepSync();

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Wizard
        startIndex={startIndex}
        header={<GuidedPlanningHeader />}
        onStepChange={onStepChange}
        wrapper={<WizardAnimatedStep />}
      >
        <FundingPlanOverviewStep />
        <AssetSelectionStep />
        <AssessmentIntroStep />
        <AssessmentAccountsStep />
        <AssessmentProjectionStep />
        <PreferencesDeathBenefitsStep />
        <PreferencesBenefitStructureStep />
        <QuotesLoadingStep />
        <QuotesSelectionStep />
        <QuotesFundingStep />
        <PlanComparisonStep />
      </Wizard>
    </div>
  );
}

export function GuidedFinancialPlanningPage({ clientId }: GuidedFinancialPlanningPageProps) {
  return (
    <GuidedPlanningProvider clientId={clientId}>
      <GuidedPlanningWizard />
    </GuidedPlanningProvider>
  );
}
